import React, { useEffect, useRef, useState } from "react";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";
import DropDownWithLabel from "../../../admin/components/common/DropDownWithlable";
import DimensionDetails from "../../../admin/components/Charts/DimensionDetails";
import RadialDimension from "../../../admin/components/Charts/RadialDimension";
import RadialDimensionHorizontal from "../../../admin/components/Charts/RadialDimensionHorizontal";
import WeightedGapChart from "../../../admin/components/Charts/GapChart";
import MaturityLine from "../../../admin/components/Charts/MaturityLine";
import { getAllCompanies } from "../../../services/api-services";
import { API_RESPONSE } from "../../../utills/app-constant";
import { toastEmitter } from "../../../utills/utilities";
import TableHeading from "../../../admin/components/common/TableHeading";
import OverallParticipationChart from "../../../admin/components/Charts/OverallParticipationChart";
import OverallParticipationChartJobLevel from "../../../admin/components/Charts/OverallParticipationChartJobLevel";
import DimenstionCurrentChart from "../../../admin/components/Charts/customerDimensionCurrent/DimenstionCurrentChart";
import DonutChart from "../../../admin/components/Charts/DonutChart";
import RadarChart from "../../../admin/components/Charts/RadarChart/RadarDimenstionChart";
import DmmSubdimensionsChart from "../../../admin/components/Charts/DmmSubimenstionChart";
import DimenstionFutureChart from "../../../admin/components/Charts/customerDimensionFuture/DimensionFutureChart";
import Dimension from "../../../admin/components/Charts/HeatMap/heatmap";
import DivisionLevelHeatamp from "../../../admin/components/Charts/HeatMap/divisionLevelHeatamp";
import JobLeveHeatmap from "../../../admin/components/Charts/HeatMap/jobLeveHeatmap";
import DivisionHeatmap from "../../../admin/components/Charts/HeatMap/divisionHeatmap";
import JobHeatMap from "../../../admin/components/Charts/HeatMap/jobHeatMap";
import CustomerMaturityLine from "../../../admin/components/Charts/CustomeChart";
import DimessionDeepDive from "../../../admin/components/Charts/dimessionDeepDive";
import MaturityBenchmark from "../../../admin/components/Charts/Benchmark";
import GraphDownloadModel from "../../../admin/components/common/GraphDownloadModel";
import DownloadGraphButton from "./DownloadGraphButton";


const GraphOverallResult = () => {
  const addbuttonClick = useRef();
  const [pending, setPending] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [loading, setLoading] = useState(false);
  const [exportloading, setexportLoading] = useState();
  const [companyList, setCompanyList] = useState([]);
  const [currentGraph, setcurrentGraph] = useState(); // For progress bar
  const [currentGraphActive, setcurrentGraphActive] = useState(false); // For progress bar

  const getallCompany = async () => {
    setPending(true);
    try {
      const response = await getAllCompanies();
      if (response?.data?.responseCode === 404) {
        setCompanyList([]);
      } else if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody.map((data) => ({
          value: data?.id,
          label: data?.companyName,
          Status: data?.status,
        }));
        setCompanyList(companyOptions);
        setPending(false);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallCompany();
  }, []);

  const chartImage = [{
    title: "Overall Participation",
    id: 'overall_participation',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Dimension Participation Details",
    id: 'dimension_participation',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Radial Details",
    id: 'radial_details',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Dimension details",
    id: 'dimension_details',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Overall Heatmap",
    id: 'overall_heatmap',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Ordered Average Weighted Gap Chart",
    id: 'gap_chart',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "DMM Sub-Dimension Results",
    id: 'DMM_Sub_Dimension',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Maturity Line – Overall versus benchmark records",
    id: 'benchmark_records',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Overall Participation (Division)",
    id: 'overall_participation_division',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Demographic Dashboard – Division",
    id: 'demographic_dashboard_division',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Demographic Dashboard – (Division Level)",
    id: 'demographic_dashboard_division_level',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Overall Participation (Job Level)",
    id: 'job_level',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Demographic Dashboard - (Job Level) First",
    id: 'demographic_dashboard_job_level',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Demographic Dashboard - (Job Level) Second",
    id: 'demographic_dashboard_job_level2',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Dimension Deep Dives – (Distribution Chart Explanation)",
    id: 'chart_explanation',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Maturity Line",
    id: 'maturity_line',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "DimensionRadarChart",
    id: 'DimensionRadarChart',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Customer Sub - Dimensions Radar charts",
    id: 'customer_sub_radar',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Customer Dimension - Current",
    id: 'customer_dimension_current',
    remark: '',
    image: '',
    subimage: [],
  },
  {
    title: "Customer Dimension - Future",
    id: 'customer_dimension_future',
    remark: '',
    image: '',
    subimage: [],
  },

  {
    title: "Maturity Benchmark Line",
    id: 'maturity_benchmark_line',
    remark: '',
    image: '',
    subimage: [],
  },
  ];

  const handleSelect = (event) => {
    const selectedCompanyId = event.target.value;
    setSelectedCompanyId(selectedCompanyId);
    localStorage.setItem("chartImageData", JSON.stringify(chartImage));
  };

  const myhandleExport = async (chartID) => {
    setexportLoading(true);
    setcurrentGraphActive(false);
    await setcurrentGraph(chartID); // Ensure the graph is set before clicking
    if (addbuttonClick.current) {
      addbuttonClick.current.click();
    }
  };

  const myhandleCloseExport = async () => {
    // const chartElements = document.querySelectorAll(".chart_element");
    // chartElements.forEach((el) => {
    //   el.style.display = "block";
    // });
  };

  return (
    <div className="overall-result">
      <div className="overall-result-content">
        <div className="page-title">
          <h5 className="mb-2">Overall Result</h5>

        </div>
        <div className="row">
          <div className="col-md-6 mb-4">
            <DropDownWithLabel
              labelName="Select Organization"
              lableclassName="input-label"
              name="companyId"
              showastrict={true}
              options={companyList}
              className="form-control inputText-lable"
              value={selectedCompanyId}
              handleSelect={handleSelect}
            />
          </div>
        </div>
        {!selectedCompanyId && (
          <div className="selectCompany mb-2">
            <TableHeading
              firstData="Please Select "
              icon={RIGHTARROW_ICON}
              TableHeading="mb-0"
              secondclassName="textcolor"
              className="textcolor"
              secondData="Organization"
            />
          </div>
        )}
        {selectedCompanyId && (
          <>
            <div class="accordion accordion-flush "  >
              <div class="accordion-item chart-container">
                <div className="chart_element graph1">
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header " id="flush-headingOne"><button class="accordion-button collapsed" type="button" > Overall Participation (completion)
                    </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">

                      <DownloadGraphButton chartID="chart1" myhandleExport={myhandleExport} />
                    </div>
                  </div>
                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body " >
                      <DonutChart selectedCompanyId={selectedCompanyId} graphName="OverallParticipation" />
                    </div>
                  </div>
                </div>

                <div className="chart_element graph2">
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header " id="flush-headingOne"><button class="accordion-button collapsed" type="button" > Dimension Participation Details
                    </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <div className="d-flex align-items-center justify-content-center resulticon_content">
                        <DownloadGraphButton chartID="chart2" myhandleExport={myhandleExport} />
                      </div>
                    </div>
                  </div>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body " >
                      <DimensionDetails selectedCompanyId={selectedCompanyId} graphName="DimensionParticipationDetails" />
                    </div>
                  </div>
                </div>

                <div className="chart_element">
                  <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" >
                      Radial + Dimension details
                    </button>
                  </h2>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body">
                      <div className="diamentionradielchart mb-3 row">
                        <div className="row">
                          <div className="col-12 col-lg-6 graph2" >

                            <div className="pdf-chart" data-heading="Radial Details">
                              <RadialDimension selectedCompanyId={selectedCompanyId} graphName="RadialDimensiondetails" myhandleExport={myhandleExport} />
                            </div>

                          </div>
                          <div className="col-12 col-lg-6 right_sec ">
                            <div className="pdf-chart" data-heading="Radial Details">
                              <RadialDimensionHorizontal
                                selectedCompanyId={selectedCompanyId}
                                graphName="RadialDimensionhorizontaldetails"
                                myhandleExport={myhandleExport}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="chart_element">
                  {/*Graph  Overall Heatmap */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        Overall Heatmap
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart5" myhandleExport={myhandleExport} />
                    </div>
                  </div>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading="Dimension Participation Details">
                      {" "}
                      {loading ? (
                        // Show a loader while the data is being fetched
                        <div className="loader-container">
                          <div className="loader"></div>
                        </div>
                      ) : (
                        <>
                          <div className="">
                            <Dimension selectedCompanyId={selectedCompanyId} graphName="OverallHeatmap" myhandleExport={myhandleExport} />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="chart_element">
                  {/* Ordered Average Weighted Gap Chart */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        Ordered Average Weighted Gap Chart
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart6" myhandleExport={myhandleExport} />
                    </div>
                  </div>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading="  Ordered Average Weighted Gap Chart">
                      {" "}
                      {loading ? (
                        // Show a loader while the data is being fetched
                        <div className="loader-container">
                          <div className="loader"></div>
                        </div>
                      ) : (
                        <WeightedGapChart selectedCompanyId={selectedCompanyId}
                          graphName="WeightedGapChart"
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="chart_element">
                  {/*   DMM Sub-Dimension results start */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        DMM Sub-Dimension results
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart7" myhandleExport={myhandleExport} />
                    </div>

                  </div>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading="DMM Sub-Dimension results">
                      <DmmSubdimensionsChart
                        selectedCompanyId={selectedCompanyId}
                        graphName="DMMSubDimensionresults"
                      />
                    </div>
                  </div>
                </div>
                {/*   DMM Sub-Dimension results end */}
                <div className="chart_element">
                  {/*     Maturity Line – Overall versus benchmark records start */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        Maturity Line – Overall versus benchmark records
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart8" myhandleExport={myhandleExport} />
                    </div>
                  </div>
                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading="DMM Sub-Dimension results">
                      <div className="benchmarkchart mb-3">
                        <MaturityLine selectedCompanyId={selectedCompanyId}
                          graphName="MaturityLineOverallversusbenchmark"
                        />
                      </div>
                    </div>
                  </div>

                  {/*     Maturity Line – Overall versus benchmark records end */}
                </div>

                <div className="chart_element">
                  {/*      Overall Participation (Division) start */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        Overall Participation (Division)
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart9" myhandleExport={myhandleExport} />
                    </div>
                  </div>
                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading=" Overall Participation (Division)">
                      <div className="OverallParticipationchart mb-3">
                        <OverallParticipationChart
                          selectedCompanyId={selectedCompanyId}
                          graphName="OverallParticipationDivision"
                        />
                      </div>
                    </div>
                  </div>
                  {/*      Overall Participation (Division) end */}
                </div>
                <div className="chart_element">
                  {/*      Demographic Dashboard – Division start */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button">
                        Demographic Dashboard – Division
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart10" myhandleExport={myhandleExport} />
                    </div>
                  </div>
                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading="Demographic Dashboard – Division">
                      <div className="Demoghraphicchart mb-3">
                        {loading ? (
                          <div className="loader-container">
                            <div className="loader"></div>
                          </div>
                        ) : (
                          <DivisionHeatmap selectedCompanyId={selectedCompanyId}
                            graphName="DemographicDashboardDivision"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {/*      Demographic Dashboard – Division end */}
                </div>

                <div className="chart_element">
                  {/*      Demographic Dashboard – (Division Level) start */}

                  <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" >
                      Demographic Dashboard – (Division Level)
                    </button>
                  </h2>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body " >
                      <div className="Demoghraphicdivisionlevelchart mb-3">
                        {loading ? (
                          <div className="loader-container">
                            <div className="loader"></div>
                          </div>
                        ) : (
                          <DivisionLevelHeatamp
                            selectedCompanyId={selectedCompanyId}
                            graphName="DemographicDashboardDivision"
                            myhandleExport={myhandleExport}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/*      Demographic Dashboard – (Division Level) end */}

                <div className="chart_element">
                  {/*      Overall Participation (Job Level) start */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        Overall Participation (Job Level)
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart12" myhandleExport={myhandleExport} />
                    </div>
                  </div>
                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading=" Overall Participation (Job Level)">
                      <div className="Joblevelbarchart mb-3">
                        <OverallParticipationChartJobLevel
                          selectedCompanyId={selectedCompanyId}
                          graphName="OverallParticipationJobLevel"
                        />
                      </div>
                    </div>
                  </div>
                  {/*       Overall Participation (Job Level) end */}
                </div>
                <div className="chart_element">
                  {/*       Demographic Dashboard - (Job Level) start */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        Demographic Dashboard – JOB LEVEL
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart13" myhandleExport={myhandleExport} />
                    </div>
                  </div>
                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading=" Overall Participation (Job Level)">
                      <div className="Joblevelbarchart mb-3">
                        <JobHeatMap selectedCompanyId={selectedCompanyId} graphName="JobHeatMap" />
                      </div>
                    </div>
                  </div>
                  {/*  Demographic Dashboard - (Job Level) end */}
                </div>
                <div className="chart_element">
                  {/*        Demographic Dashboard - (Job Level) start */}
                  {/* <div className="d-flex justify-content-between"> */}
                  <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" >
                      Demographic Dashboard – Job Level
                    </button>
                  </h2>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body " >
                      <div className="Joblevelbarchart mb-3">
                        <JobLeveHeatmap selectedCompanyId={selectedCompanyId} graphName="DemographicDashboard" myhandleExport={myhandleExport} />
                      </div>
                    </div>
                  </div>
                  {/*  Demographic Dashboard - (Job Level) end */}
                </div>


                <div className="chart_element">
                  {/*         Dimension Deep Dives – (Distribution Chart Explanation) start */}
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed" type="button" >
                        Dimension Deep Dives – (Distribution Chart Explanation)
                      </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      <DownloadGraphButton chartID="chart15" myhandleExport={myhandleExport} />

                    </div>
                  </div>
                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading=" Dimension Deep Dives – (Distribution Chart Explanation)">
                      <div className="Joblevelbarchart mb-3">
                        <DimessionDeepDive selectedCompanyId={selectedCompanyId} graphName="DimensionDeepDives" />
                      </div>
                    </div>
                  </div>
                  {/*   Dimension Deep Dives – (Distribution Chart Explanation) end */}
                </div>

                <div className="chart_element">
                  <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" >
                      Maturity Line
                    </button>
                  </h2>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading="  Maturity Line">
                      <div className="Joblevelbarchart mb-3">
                        <CustomerMaturityLine selectedCompanyId={selectedCompanyId} graphName="CustomerMaturityLine" myhandleExport={myhandleExport} />
                      </div>
                    </div>
                  </div>

                  {/*   Maturity Line end */}
                </div>
                <div className="chart_element">
                  {/*   Maturity Line start */}

                  <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" >
                      Sub - Dimensions Radar charts
                    </button>
                  </h2>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading="  Maturity Line">
                      <div className="Joblevelbarchart mb-3">
                        <RadarChart selectedCompanyId={selectedCompanyId} graphName="DimensionsRadar" myhandleExport={myhandleExport} />
                      </div>
                    </div>
                  </div>
                  {/*   Maturity Line end */}
                </div>

                <div className="chart_element">

                  {/*               Dimension - Current start */}

                  <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" >
                      Dimension - Current
                    </button>
                  </h2>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body " >
                      <div className="Joblevelbarchart mb-3">
                        <DimenstionCurrentChart
                          selectedCompanyId={selectedCompanyId} graphName="CustomerDimensionCurrent" myhandleExport={myhandleExport}
                        />
                      </div>
                    </div>
                  </div>

                  {/*  Dimension - Current end*/}
                </div>

                <div className="chart_element graph19">

                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header " id="flush-headingOne"><button class="accordion-button collapsed" type="button" >  Dimension - Future
                    </button>
                    </h2>

                  </div>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body" >
                      <div className="Joblevelbarchart mb-3 ">


                        <DimenstionFutureChart
                          selectedCompanyId={selectedCompanyId} graphName="CustomerDimensionFuture" myhandleExport={myhandleExport}
                        />
                      </div>
                    </div>
                  </div>

                  {/*  Dimension - Future  end*/}
                </div>
                <div className="chart_element">
                  {/*    Maturity Benchmark Line  start */}

                  <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" >
                      Maturity Benchmark Line
                    </button>
                  </h2>

                  <div id="flush-collapseOne" class="accordion-collapse collapse show" >
                    <div class="accordion-body pdf-chart" data-heading=" Maturity Benchmark Line">
                      <div className="Joblevelbarchart mb-3">
                        <MaturityBenchmark selectedCompanyId={selectedCompanyId} graphName="MaturityBenchmarkLine" myhandleExport={myhandleExport} />
                      </div>
                    </div>
                  </div>

                  {/* Maturity Benchmark Line  end*/}

                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <GraphDownloadModel
        heading="Download PDF and IMAGE"
        modalClick={addbuttonClick}
        title="Download PDF and IMAGE"
        currentGraph={currentGraph}
        currentGraphActive={currentGraphActive}
        modalClose={myhandleCloseExport} // Replace with your function
        buttonLable="Update"
        className="modal-lg"
      />
    </div>


  );
};

export default GraphOverallResult;
